import { EMPTY_LIST } from '../../../../constants/common'

export function toChecklistTemplateSelectItem(template) {
  return {
    label: template.name,
    value: template.id,
  }
}

export function toChecklistTemplateSelectItems(templates = EMPTY_LIST) {
  return templates.map(toChecklistTemplateSelectItem)
}
